import Shape from '../../images/process/item-shape.svg'
import img1 from '../../images/h1.png'
import img2 from '../../images/h4.png'
import img3 from '../../images/h5.png'
import img4 from '../../images/h2.png'
import img5 from '../../images/h3.png'


const ProcessData = [
    {
        id: '1',
        Img: img4,
        title: 'Customer-Focused Experience',
        desctiption: 'Our business was built with one focus in mind – to provide an exceptional experience for businesses who need their freight looked after.',
        Shapebg: Shape,
    },
    {
        id: '2',
        Img: img2,
        title: 'Flexible Pricing',
        desctiption: 'Tailored pricing structure to suit your business.',
        Shapebg: Shape,
    },
    {
        id: '3',
        Img: img3,
        title: 'Personalised Approach',
        desctiption: 'Personalised service – we don’t believe in one-size-fits-all.',
        Shapebg: Shape,
    },
    {
        id: '4',
        Img: img1,
        title: 'Dedicated Support',
        desctiption: 'Dedicated account managers who will be your one point of contact, removing the frustration of getting bounced around.',
        Shapebg: Shape,
    },
    {
        id: '5',
        Img: img5,
        title: 'Transparency & Tracking',
        desctiption: 'Transparency and open communication with real-time tracking and online POD’s.',
        Shapebg: Shape,
    },
]
const ProcessSection = (props) => {

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className='row'>
                    <div class="col-12 col-lg-10 offset-lg-1 how-works">
                        <div class="wpo-section-title">
                            <h2>Smart, Simple & Reliable</h2>
                            <h3 className='text-white mb-4'>
                                How It Works
                            </h3>
                            <p className='text-white'>
                                OFL works with all types of businesses small, medium to large. Simply pick up the phone and call, or email us with your requirements. Once we’ve reviewed your freight needs we’ll send through a full quote and proposal and help you get your freight to your destination. We’ll keep you up to date every step of the way.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="process-wrap">
                    <div className="row">
                        {ProcessData.slice(0, 5).map((proce, item) => (
                            <div className="col col-lg col-md-6 col-12" key={item}>
                                <div className="process-item">
                                    <div className="top-contnent">
                                        <img src={proce.Img} alt="" />
                                        <div className="item-shape">
                                            <img src={proce.Shapebg} alt="" />
                                        </div>
                                        <div className="text">
                                            <span>Step - {proce.id}</span>
                                        </div>
                                        <div className="shape-1">
                                            <svg width="158" height="89" viewBox="0 0 158 89" fill="none">
                                                <g opacity="0.15">
                                                    <path d="M0.0332031 30.3796L157.05 0L157.354 43.7086L30.269 88.9426"
                                                        fill="#868686" />
                                                </g>
                                            </svg>
                                        </div>
                                        <div className="shape-2">
                                            <svg width="48" height="17" viewBox="0 0 48 17" fill="none">
                                                <path
                                                    d="M47.3549 0.599976L22.8851 16.5564L0.691406 12.5793L47.3549 0.599976Z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="content">
                                        <h2>{proce.title}</h2>
                                        <p>
                                            {proce.desctiption}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="border-shape">
                        <svg width="1014" height="93" viewBox="0 0 1014 93" fill="none">
                            <path
                                d="M1 50.9659C56.3481 18.4898 187.969 -31.1736 271.668 29.9813C376.292 106.425 467.026 98.4469 528 77.5C594.713 54.5817 761.5 15.5 831.5 24C901.5 32.5 936.5 57 1013.5 75"
                                stroke="#C4CDD3" strokeWidth="1.5" strokeDasharray="2 2" />
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;